import { useEffect, useRef, useState } from 'react';

/**
 * Hook to trigger an "in-view" class once an element scrolls into the viewport.
 * Returns a ref to attach to the target element.
 */
export function useReveal(threshold = 0.15) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return undefined;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        observer.disconnect();
                    }
                });
            },
            { threshold, rootMargin: '0px 0px -8% 0px' },
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [threshold]);

    return [ref, visible];
}
